import { Text } from 'foundations-components/components/Text';
import MdxHeader from './MdxHeader';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledH2 = props => /*#__PURE__*/_jsx(Text, Object.assign({}, props, {
  as: "h2"
}));
function MdxH2(props) {
  const {
    children
  } = props;
  return /*#__PURE__*/_jsx(MdxHeader, {
    marginBlockStart: "1100",
    marginBlockEnd: "400",
    Component: StyledH2,
    children: children
  });
}
export default MdxH2;